module.exports = __webpack_public_path__ + "static/media/Close.d6451ab8.svg";